import { useContext } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";
import { Image } from "../../Image/Image";
import { monthNames, transformDate } from "../data";

const DetailBody = () => {
	const { dictionaryWords, moreInfoCard } = useContext(SportsCampsContext);


	return (
		<div className="c-detail-fiche__body">
			<div className="practical">
				<div className="left">
					<div className="inner">
						<div className="bottom">
							<div className="info">
								<p className="title">
									{dictionaryWords.location}
								</p>
								<p>{moreInfoCard.location.locationName}</p>
							</div>
							<div className="info">
								<p className="title">
									{dictionaryWords.period}
								</p>
								{transformDate(moreInfoCard.period.from) ===
								transformDate(moreInfoCard.period.until) ? (
									<p>
										{transformDate(
											moreInfoCard.period.from
										)}
									</p>
								) : (
									<p>{`${transformDate(
										moreInfoCard.period.from
									)} - ${transformDate(
										moreInfoCard.period.until
									)}`}</p>
								)}
							</div>
							<div className="info">
								<p className="title">
									{dictionaryWords.careType}
								</p>
								<p>{moreInfoCard.careType}</p>
							</div>
							<div className="info">
								<p className="title">
									{dictionaryWords.ageCategory}
								</p>
								<p>{moreInfoCard.ageDescription}</p>
							</div>
							<div className="info">
								<p className="title">{dictionaryWords.price}</p>
								<p>{`€ ${moreInfoCard.price}`}</p>
							</div>
						</div>
					</div>
				</div>
				<div className="right">
					<div className="inner">
						<div className="info">
							<p ng-bind-html="sportsCamp.description">
								{moreInfoCard.description}
							</p>
						</div>
						{moreInfoCard.freePlaces > 0 && (
							<div>
								<h3>{dictionaryWords.registerNow}</h3>
								{moreInfoCard.freePlaces > 1 ? (
									<p>
										{`${dictionaryWords.thereAreStill} ${moreInfoCard.freePlaces} ${dictionaryWords.spotsAvailable}`}
									</p>
								) : (
									<p>
										{`${dictionaryWords.thereIsStill} ${moreInfoCard.freePlaces} ${dictionaryWords.spotAvailable}`}
									</p>
								)}
								<a
									href={moreInfoCard.shopUrl}
									className="c-button recreatex-link"
									title={`bekijk ${moreInfoCard.activityName} op recreatex`}
								>
									{dictionaryWords.registerNow}
								</a>
							</div>
						)}
						{moreInfoCard.freePlaces === 0 && (
							<div>
								<p>{dictionaryWords.full}</p>
								<a
									href={moreInfoCard.shopUrl}
									onClick={() => {}}
									className="c-button recreatex-link"
									title={`bekijk ${moreInfoCard.activityName} op recreatex`}
								>
									{dictionaryWords.waitingList}
								</a>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default DetailBody;
